import React, { forwardRef } from "react";

import { StyledCheckboxWrapper } from "./checkboxField.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../genericInputFields/genericInputField";
import useSolutionForm from "../../../../hooks/useSolutionForm";

const CheckboxField = forwardRef(({ data, name, error }, ref) => {
  const { id, required, title, optionGroups, restricted } = data;
  const {
    formMethods: { register },
    disableRestrictedFields,
  } = useSolutionForm();

  return (
    <StyledCheckboxWrapper ref={ref} error={error ? 1 : 0}>
      <Label required={required}>{title}</Label>
      <input
        type="hidden"
        value={id}
        {...register(`${name}.supplemental_submission_field_id`)}
      />
      {optionGroups.map(({ label, options }, idx) => (
        <>
          {label && <div>{label}</div>}
          {options.map((option, index) => (
            <div key={`${idx}${index}`}>
              <GenericInputField
                type={TYPES.CHECKBOX}
                register={register}
                value={option}
                name={`${name}.answer`}
                required={required}
                readOnly={restricted && disableRestrictedFields}
              />
            </div>
          ))}
        </>
      ))}
      <span className="error">{error?.message || ""}</span>
    </StyledCheckboxWrapper>
  );
});
CheckboxField.displayName = "CheckboxField";

export default CheckboxField;

// "id": 6246,
// "title": "<p>Checkbox agree?</p>",
// "fieldType": "check_box",
// "required": false,
// "options": "yes, no",
// "placeholder": "",
// "groupId": "",
// "maxCharacters": null,
// "minValue": null,
// "maxValue": null,
// "stepValue": null,
// "order": null,
// "restricted": false,
// "type": "supplemental"
